import { defineCopy, formatCurrency } from "@tami/core/intl";

import { CALCULATOR_SCRIPT_COPY_EN_US } from "./en-us/calculator-script.copy";
import { CALCULATOR_SCRIPT_COPY_ES_ES } from "./es-es/calculator-script.copy";

export const CALCULATOR_SCRIPT_COPY_PT_BR = {
  calcIntro: {
    narrative:
      "Calculadora de publis: precifique entregas com critério, salve estratégias e reutilize quando a proposta chegar.",
  },
  calcToolbar: {
    narrative:
      "Busque cálculos salvos, oculte valores na tela e abra um novo quando quiser testar outra combinação de entregáveis.",
    callout:
      "Busque por nome, controle a visibilidade dos valores e crie um cálculo novo em um clique.",
  },
  calcOverview: {
    narrative:
      "Cada estratégia fica guardada com título, investimento sugerido e data da última atualização.",
  },
  calcCards: {
    narrative:
      "Veja o valor sugerido de cada publi num relance — pronto para enviar à marca ou transformar em campanha.",
    callout:
      "Cards com investimento, badge de valor sugerido e histórico de atualização.",
  },
  calcCardValue: {
    narrative:
      "O investimento consolidado considera entregáveis, tempo de produção e margem — sem planilha manual.",
    callout:
      "Valor sugerido calculado com base nos parâmetros da sua estratégia de publi.",
  },
  calcNew: {
    narrative:
      "Novo cálculo abre o simulador completo: redes, formatos, prazos e margem — tudo configurável.",
    callout:
      "+ Novo cálculo — monte uma proposta do zero ou duplique uma existente.",
  },
  calcModalOpen: {
    narrative:
      "A calculadora abre num modal: preencha perfil, entregáveis e extras enquanto o valor se atualiza ao vivo.",
    callout:
      "Nova precificação — simulador completo sem sair da lista de cálculos.",
  },
  calcModalTitle: {
    narrative:
      "Dê um nome ao cálculo — collab, pacote mensal ou proposta avulsa, fácil de achar depois.",
    callout:
      "Nomeie a estratégia — ex.: Collab moda verão.",
  },
  calcModalProfile: {
    narrative:
      "Nicho e tempo de carreira entram no cálculo — a Tãmi ajusta a faixa de preço ao seu perfil.",
    callout:
      "Perfil do creator: nicho e experiência influenciam mínimo, média e máximo.",
  },
  calcModalDeliverables: {
    narrative:
      "Informe redes, seguidores e quantos reels ou stories entram — o escopo define o valor base.",
    callout:
      "Entregáveis por rede — reels, stories e demais formatos configuráveis.",
  },
  calcModalExtras: {
    narrative:
      "Exclusividade, impulsionamento e custos extras sobem ou descem a proposta na hora.",
    callout:
      "Extras como exclusividade entram no cálculo automaticamente.",
  },
  calcModalResult: {
    narrative:
      "Mínimo, média e máximo aparecem no topo — veja a faixa sugerida antes de enviar à marca.",
    get callout(): string {
      return `${formatCurrency(2709)} na média — faixa completa visível enquanto você ajusta os campos.`;
    },
  },
  calcModalSave: {
    narrative:
      "Salve a precificação e reutilize quando a proposta chegar — ou transforme direto em campanha.",
    callout:
      "Salvar precificação — copie, exporte ou guarde na sua biblioteca de cálculos.",
  },
} as const;

export const CALCULATOR_SCRIPT_COPY = defineCopy(CALCULATOR_SCRIPT_COPY_PT_BR, {
  "en-US": CALCULATOR_SCRIPT_COPY_EN_US,
  "es-ES": CALCULATOR_SCRIPT_COPY_ES_ES,
});
